<template>
    <Reports />
</template>

<script>
import Reports from "@/components/reports/Reports.vue";
import { mapGetters } from "vuex";

export default {
    name: "reports-view",
    components: {
        Reports,
    },
    computed: {
        ...mapGetters("oidcStore", ["oidcUser"]),
        isSupervisor() {
            let roles = this.oidcUser.role;
            return roles.indexOf("Supervisor") > -1;
        },
    },
    mounted() {
        if (!this.isSupervisor) {
            this.$router.push({ name: "home" });
        }
    }
};
</script>